export default function scrollTo<T extends HTMLElement>(targetElement: T) {
  window.scrollTo({
    top: targetElement.offsetTop,
    behavior: "smooth",
  });
}
